import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "utils/enums";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { usePermissions } from "./usePermissions";

interface ProtectedRouteProps extends PropsWithChildren {
    permissionRequired?: UserPermissions;
    featureFlagEnabled?: boolean;
}

function ProtectedRoute({ children, permissionRequired, featureFlagEnabled }: ProtectedRouteProps) {
    const navigate = useNavigate();
    const { hasPermission, isLoading } = usePermissions();

    useEffect(() => {
        if (!isLoading && permissionRequired && !hasPermission(permissionRequired)) {
            navigate("/portfolio");
        }

        if (!isLoading && featureFlagEnabled) {
            navigate("/portfolio");
        }
    }, [hasPermission, isLoading, navigate, featureFlagEnabled]);

    if (isLoading) {
        return <LoadingSpinner />;
    }

    return <div>{children}</div>;
}

export default ProtectedRoute;
